const { inviteErrorMessage } = require('../utils/agentApi');

const COMPOSER_ERRORS = new Set([
  'network',
  'email_not_configured',
  'provider_rejected',
  'unsubscribe_not_configured',
  'postal_address_not_configured',
]);

function inviteMailto({ email, subject, body }) {
  const to = String(email || '').trim();
  const query = [
    `subject=${encodeURIComponent(subject || 'Your Pacarion invite')}`,
    `body=${encodeURIComponent(body || '')}`,
  ].join('&');
  return `mailto:${to}?${query}`;
}

/**
 * What the Email invite button should do with one server response.
 * A clean send stays in the app. A mail-server failure opens Mail.
 * A block (unsubscribed, limit, already joined) stays on the popup.
 */
function resolveInviteSend(body, requestFailed) {
  const result = body && Array.isArray(body.results) ? body.results[0] : null;
  if (!requestFailed && result && result.invite_status === 'sent' && !result.error) {
    return {
      state: 'emailed',
      toast: 'Invite sent',
      line: 'Invite sent. It was emailed.',
      invite_status: 'sent',
      invite_error: null,
      invite_channel: 'email',
    };
  }
  const code = (result && result.error) || (requestFailed ? 'network' : '');
  if (code && !COMPOSER_ERRORS.has(code)) {
    const message = inviteErrorMessage(code) || "Couldn't send the email.";
    return {
      state: 'blocked',
      toast: message,
      line: `Not emailed. ${message}`,
      invite_status: (result && result.invite_status) || 'not_sent',
      invite_error: code,
      invite_channel: null,
    };
  }
  return {
    state: 'composer',
    toast: 'Invite sent',
    line: 'Invite sent. It opened in Mail.',
    invite_status: 'sent',
    invite_error: null,
    invite_channel: 'mail',
  };
}

function invitePopupLine(result) {
  if (!result || result.outcome === 'linked') return '';
  if (result.invite_channel === 'mail') return 'Invite sent. It opened in Mail.';
  if (result.invite_status === 'sent') return 'Invite sent. It was emailed.';
  if (result.invite_error) {
    const message = inviteErrorMessage(result.invite_error) || "Couldn't send the email.";
    return `Not emailed. ${message}`;
  }
  return 'Not emailed yet.';
}

module.exports = {
  COMPOSER_ERRORS,
  inviteMailto,
  resolveInviteSend,
  invitePopupLine,
};
